import { scaleOrdinal } from "d3-scale";
import { schemeCategory10 } from "d3-scale-chromatic";
import React from "react";
import { useAccountID } from "../store/account";
import { useShowID } from "../store/show";
import { useTopCountries } from "../store/top-countries";
import PieChart from "./PieChart";

const percentFormat = new Intl.NumberFormat(undefined, { style: "percent" }).format;

export default function TopCountries() {
    const accountID = useAccountID();
    const showID = useShowID();
    const { data: countries } = useTopCountries(accountID, showID) || {};

    const colorScale = scaleOrdinal(schemeCategory10);

    return (
        <>
            <PieChart data={countries} colors={colorScale} namePrefix="country" />
            <table className="table">
                <thead>
                    <tr>
                        <th style={{ textAlign: "center" }}>Rank</th>
                        <th>Country</th>
                        <th style={{ textAlign: "right" }}>%</th>
                    </tr>
                </thead>
                <tbody>
                    {countries &&
                        countries.map(c => (
                            <tr key={c.countryName}>
                                <td style={{ textAlign: "center" }}>{c.countryRank}</td>
                                <td style={{ textAlign: "left", display: "flex" }}>
                                    <div
                                        style={{
                                            flexShrink: 0,
                                            width: "0.8em",
                                            height: "0.8em",
                                            marginRight: "0.25em",
                                            marginTop: "0.2em",
                                            background: colorScale(c.countryName)
                                        }}
                                    />
                                    {c.countryName}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {percentFormat(c.downloads / c.totalDownloads)}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </>
    );
}
